import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Actions
import {
    requestLoadReportsHarvestInspectionsPeople,
    requestPollingReportsHarvestInspectionsPeople,
    canceledPollingReportsHarvestInspectionsPeople
} from '../../../../../../services/reportsHarvestInspectionsPeople/actions';

// Selectors
import { makeSelectParameters } from './selectors';

interface Props {
    parameters: Record<string, any>;
    requestLoadReportsHarvestInspectionsPeople: Function;
    requestPollingReportsHarvestInspectionsPeople: Function;
    canceledPollingReportsHarvestInspectionsPeople: Function;
}

export class ReportsHarvestInspectionsPeopleRequest extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.requestLoadReportsHarvestInspectionsPeople();
        this.props.requestPollingReportsHarvestInspectionsPeople();
    }

    componentDidUpdate(prevProps: Props) {
        // Update if request parameters change
        if (!isEqual(prevProps.parameters, this.props.parameters)) {
            this.props.requestLoadReportsHarvestInspectionsPeople();
        }
    }

    componentWillUnmount() {
        this.props.canceledPollingReportsHarvestInspectionsPeople();
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    parameters: makeSelectParameters()
});

export default connect(
    mapStateToProps,
    {
        requestLoadReportsHarvestInspectionsPeople,
        requestPollingReportsHarvestInspectionsPeople,
        canceledPollingReportsHarvestInspectionsPeople
    }
)(ReportsHarvestInspectionsPeopleRequest);
